import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Register, User, Office, Login,AccountHeadDetails,AccountSubHeadDetails,Expenditure,SainikSchemeApplicationModel,SainikSchemeApplicationStatusHistoryModel,CorrespondanceTrackingModel,GrievancesLodging } from './shared/user.model';


@Injectable()
export class RegistrationService {
// baseurl:string;

httpOptions: any;

//readonly baseurl="http://localhost:14055/";
 //readonly baseurl="http://sainikapi.esdinfra.com/";
//readonly baseurl="http://sainikstagingapi.esdinfra.com/";
readonly baseurl="http://uatsainikapi.esdinfra.com/";
  
  constructor(public http: HttpClient) {
   let accesstoken = localStorage.getItem('accessToken');
   if (accesstoken != null && accesstoken != '' && typeof (accesstoken) != undefined) {
     this.httpOptions = {
       headers: new HttpHeaders({
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + accesstoken,
         'No-Auth': 'True'
       })
     };
   }
   }

   getAllowedPages() {
    let accesstoken = localStorage.getItem('accessToken');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + accesstoken
      })
    };
    return this.http.get(this.baseurl + '/api/AllowedPages', this.httpOptions);
  }

    doregister(data:any){    
    return this.http.post(this.baseurl+"api/SainikRegistrationDEForm",data,this.httpOptions);
  }

  uploadImage(data){    
    console.log(data);
    return this.http.post(this.baseurl+"api/SainikRegistration/image",data);
  }
  getfinalize(SR_ServiceNo:any){  
    debugger;  
    return this.http.get(this.baseurl+"api/SainikBasicRegistration/GetFinalizedData/"+SR_ServiceNo,this.httpOptions);
  }
  getIdCardNumbers()
  {
    return this.http.get(this.baseurl+"api/SainikBasicRegistration/GetIdCardNumbers/",this.httpOptions);
  }
  getRegiments()
  {
    return this.http.get(this.baseurl+"api/SainikBasicRegistration/GetSainikRegiments/",this.httpOptions);
  }
  getfinalizedDataForAwards(SR_ServiceNo:any){  
    debugger;  
    return this.http.get(this.baseurl+"api/SainikAwards/GetFinalizedDataForAwards/"+SR_ServiceNo,this.httpOptions);
  }
  getfinalizedDataForBattle(SR_ServiceNo:any){  
    debugger;  
    return this.http.get(this.baseurl+"api/SainikBattleCasualty/GetFinalizedDataForBattle/"+SR_ServiceNo,this.httpOptions);
  }
  getfinalizeforDependents(SR_ServiceNo:any){  
    debugger;  
    return this.http.get(this.baseurl+"api/SainikDependents/GetfinalizeforDependents/"+SR_ServiceNo,this.httpOptions);
  }
  getfinalizeForPension(SR_ServiceNo:any){  
    debugger;  
    return this.http.get(this.baseurl+"api/SainikPension/GetfinalizeForPension/"+SR_ServiceNo,this.httpOptions);
  }
  getfinalizeForUploads(SR_ServiceNo:any){  
    debugger;  
    return this.http.get(this.baseurl+"api/SainikUploads/GetfinalizeForUploads/"+SR_ServiceNo,this.httpOptions);
  }
  getfinalizeForBankInfo(SR_ServiceNo:any){  
    debugger;  
    return this.http.get(this.baseurl+"api/SainikBankDetails/GetfinalizeForBankInfo/"+SR_ServiceNo,this.httpOptions);
  }
  getSainikDetails(SR_ServiceNo:any){  
  debugger;  
  return this.http.get(this.baseurl+"api/SainikRegistration/GetDetails"+SR_ServiceNo,this.httpOptions);
  }

  checkSainikExist(SR_ServiceNo:any){  
    debugger;  
    return this.http.get(this.baseurl+"api/SainikRegistration/CheckServiceNoExist/"+SR_ServiceNo,this.httpOptions);
  }


  getAllRanks(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllRanks",this.httpOptions);
  }

  getAllCorps(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllCorps",this.httpOptions);
  }

  getRankLevels(SR_Corps:any,SR_Rank:any,HonoraryRank:any){
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllRankLevels/"+ SR_Corps +"/" +SR_Rank+"/"+HonoraryRank,this.httpOptions);
  }

  getAllQualification(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllQualifications",this.httpOptions);
  }

  getAllCivilTypes(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllCivilTypes",this.httpOptions);
  }

  getAllEquivalentTypes(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllEquivalentTypes",this.httpOptions);
  }

  getAllServiceTypes(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllServiceTypes",this.httpOptions);
  }

  getAllServiceCategories(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllServiceCategories",this.httpOptions);
  }

  getAllRelegions(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllRelegions",this.httpOptions);
  }

  getAllCaste(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllCaste",this.httpOptions);
  }

  getAllRelations(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllRelations",this.httpOptions);
  }

  getAllOccupationTypes(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllOccupationTypes",this.httpOptions);
  }

  getAllDocumentTypes(){    
    return this.http.get(this.baseurl+"api/SainikUploads/GetAllDocumentTypes",this.httpOptions);
  }


  getAllStates(enteredText:any){    
    return this.http.get(this.baseurl+"api/State/speedsearch/"+ enteredText,this.httpOptions);
  }
  getAllDistricts(enteredText:any){    
    return this.http.get(this.baseurl+"api/District/speedsearch/"+ enteredText,this.httpOptions);
  }
  getAllTaluks(enteredText:any){    
    return this.http.get(this.baseurl+"api/Taluk/speedsearch/"+ enteredText,this.httpOptions);
  }
  getAllVillages(enteredText:any){    
    return this.http.get(this.baseurl+"api/Village/speedsearch/"+ enteredText,this.httpOptions);
  }
  //
  getStates(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetStates",this.httpOptions);
  }
  getDistricts(stateId){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetDistricts/"+stateId,this.httpOptions);
  }
  getTaluks(districtId){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetTaluks/"+districtId,this.httpOptions);
  }
  getVillages(talukId){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetVillages/"+talukId,this.httpOptions);
  }

  getAllPensionTypes(){    
    return this.http.get(this.baseurl+"api/SainikPension/GetAllPensionTypes",this.httpOptions);
  }

  getAllPensionCategory(pensionTypeId:any){    
            return this.http.get(this.baseurl+"api/SainikPension/GetAllPensionCategory/" + pensionTypeId,this.httpOptions);
  }
  getAllPensionCategies(){    
    return this.http.get(this.baseurl+"api/SainikPension/GetAllPensionCategies" ,this.httpOptions);
}

  
  getAllMilitaryQualifications(){    
    return this.http.get(this.baseurl+"api/SainikPension/GetAllMilitaryQualifications",this.httpOptions);
  }

  //Save Basic registration
  saveBasicRegistration(data:any){    
    return this.http.post(this.baseurl+"api/SainikRegistrationDEForm",data,this.httpOptions);
  }

  saveSainikBasicRegistration(data:any){    
    return this.http.post(this.baseurl+"api/SainikBasicRegistration",data,this.httpOptions);
  }

  insertFinalize(SR_ServiceNo){    
    return this.http.post(this.baseurl+"api/SainikBasicRegistration/InsertFinalizeData/"+SR_ServiceNo,this.httpOptions);
  }

  getAllAwardsMasters(){
    return this.http.get(this.baseurl+"api/SainikAwards/GetAllAwardsMasters",this.httpOptions);
  }
  getAllAwardTypes(){
    return this.http.get(this.baseurl+"api/SainikAwards/getAllAwardTypes",this.httpOptions);
  }

  getAllCasualtyType(){
    return this.http.get(this.baseurl+"api/SainikBattleCasualty/CasualtyTypes",this.httpOptions);
  }

  getSainikBasicDetailsForAwards(SR_ServiceNo){
    return this.http.get(this.baseurl+"api/SainikAwards/GetSainikDetails/"+SR_ServiceNo,this.httpOptions);
  }
  
  getSainikBasicDetailsForBattle(SR_ServiceNo){
    return this.http.get(this.baseurl+"api/SainikBattleCasualty/GetSainikDetails/"+SR_ServiceNo,this.httpOptions);
  }

  getSainikBasicDetailsForDependents(SR_ServiceNo){
    return this.http.get(this.baseurl+"api/SainikDependents/GetSainikDetails/"+SR_ServiceNo,this.httpOptions);
  }

  getSainikBasicDetailsForBanks(SR_ServiceNo){
    return this.http.get(this.baseurl+"api/SainikBankDetails/GetSainikDetails/"+SR_ServiceNo,this.httpOptions);
  }

  getSainikBasicDetailsForBasicRegistration(SR_ServiceNo){
    return this.http.get(this.baseurl+"api/SainikBasicRegistration/GetSainikDetails/"+SR_ServiceNo,this.httpOptions);
  }

  getSainikDetailsFromRegistration(SR_ServiceNo){
    return this.http.get(this.baseurl+"api/SainikBasicRegistration/GetDetailsFromRegistration/"+SR_ServiceNo,this.httpOptions);
  }
  
  getSainikBasicDetailsForUploads(SR_ServiceNo){
  return this.http.get(this.baseurl+"api/SainikUploads/GetSainikDetails/"+SR_ServiceNo,this.httpOptions);
   }

   getSainikBasicDetailsForPension(SR_ServiceNo){
    return this.http.get(this.baseurl+"api/SainikPension/GetSainikDetails/"+SR_ServiceNo,this.httpOptions);
     }

     deleteDependent(Did:any){
     return this.http.put(this.baseurl+"api/SainikDependents/DeleteDependent/"+Did,this.httpOptions);
    }

    deleteUpload(DuploadId:any){
      return this.http.put(this.baseurl+"api/SainikUploads/DeleteUpload/"+DuploadId,this.httpOptions);
     }

     
  //Save Battle Casualty
  saveBattleCasualty(serviceNo:any,sainikId:any,data:any){ 
    data['SR_Id'] = sainikId;
    ///debugger;
  //console.log(data);
    return this.http.post(this.baseurl+"api/SainikBattleCasualty/"+serviceNo+"/",data,this.httpOptions);
  }

  updateBattleCasualty(serviceNo:any,sainikId:any,data:any){ 
    data['SBC_SR_Id_FK'] = sainikId;
    return this.http.put(this.baseurl+"api/SainikBattleCasualty/Update/"+serviceNo+"/",data,this.httpOptions);
  }

  UpdateSainikPension(sainikId:any,data:any){ 
    data['SP_SR_Id_FK'] = sainikId;
    return this.http.put(this.baseurl+"api/SainikPension/Update",data,this.httpOptions);
  }

  updateBasicRegistration(sainikId:any,data:any){ 
    data['SR_Id'] = sainikId;
    return this.http.put(this.baseurl+"api/SainikBasicRegistration/Update",data,this.httpOptions);
  }

  saveDependents(sainikId:any,data:any){ 
    debugger;
    return this.http.post(this.baseurl+"api/SainikDependents/"+sainikId, data,this.httpOptions);
  }

  updateDependents(sainikId:any,data:any){ 
    debugger;
    return this.http.post(this.baseurl+"api/SainikDependents/Update"+sainikId, data,this.httpOptions);
  }

  saveSainikAwards(sainikId:any,data:any){ 
    data['SR_Id'] = sainikId;
    return this.http.post(this.baseurl+"api/SainikAwards",data,this.httpOptions);
  }

  saveSainikPension(sainikId:any,data:any){    
    data['SP_SR_Id_FK'] = sainikId;
    return this.http.post(this.baseurl+"api/SainikPension",data,this.httpOptions);
  }

  updateSainikAwards(sainikId:any,data:any){ 
    data['SR_Id'] = sainikId;
    return this.http.put(this.baseurl+"api/SainikAwards/Update",data,this.httpOptions);
  }

  saveSainikBankDetails(sainikId:any,data:any){ 
    data['SBD_SR_Id_FK'] = sainikId;
    return this.http.post(this.baseurl+"api/SainikBankDetails",data,this.httpOptions);
  }

  updateSainikBankDetails(sainikId:any,data:any){ 
    data['SBD_SR_Id_FK'] = sainikId;
    return this.http.put(this.baseurl+"api/SainikBankDetails/Update",data,this.httpOptions);
  }

  saveSainikUploads(serviceNo:any,sainikId:any,data:any){ 
    debugger;
    data['SDU_SR_Id_FK'] = sainikId;
   // return this.http.post(this.baseurl+"api/SainikUploads/Insert/sainikId",data,this.httpOptions);
   //return this.http.post(this.baseurl+"api/SainikUploads",data,this.httpOptions);
   return this.http.post(this.baseurl+"api/SainikUploads/"+serviceNo+"/"+sainikId,data,this.httpOptions);
  }


  //sainik bank details
  getAllBanks(){    
    return this.http.get(this.baseurl+"api/SainikBankDetails/GetAllBanks",this.httpOptions);
  }

  getAllBankBranches(BankId){    
    return this.http.get(this.baseurl+"api/SainikBankDetails/GetAllBankBranches/"+BankId,this.httpOptions);
  }

  getAllBankAccountOf(){    
    return this.http.get(this.baseurl+"api/SainikBankDetails/GetAllBankAccountOf",this.httpOptions);
  }

  getIFSC(BranchId){
    return this.http.get(this.baseurl+"api/SainikBankDetails/GetIFSC/"+BranchId,this.httpOptions);
  }

  getSainikCompleteDetails(SR_ServiceNo:any){    
    return this.http.get(this.baseurl+"api/SainikBasicRegistration/GetSainikViewForm/"+SR_ServiceNo,this.httpOptions);
  }

//Authorization and Authentication methods

  getAllRoles(itemsPerPage: number, pageNo: number) {
    debugger;
    return this.http.get(this.baseurl + '/api/Roles/GetAll/' + itemsPerPage+"/"+pageNo, this.httpOptions);
  }

  getAllUsers(itemsPerPage: number, pageNo: number) {
    debugger;
    return this.http.get(this.baseurl + '/api/Users/GetAll/' + itemsPerPage+"/"+pageNo, this.httpOptions);
  }
  getAllClaimsForTheRole(roleId: string) {
    return this.http.get(this.baseurl + '/api/Claims/' + roleId, this.httpOptions);
  }
  getRoleForTheId(roleId: string) {
    return this.http.get(this.baseurl + '/api/Roles/' + roleId, this.httpOptions);
  }

  getUserForTheId(Id: string) {
    return this.http.get(this.baseurl + '/api/Users/' + Id, this.httpOptions);
  }
  
  getOfficeForTheId(OfficeId: string) {
       return this.http.get(this.baseurl + '/api/Offices/' + OfficeId, this.httpOptions);
  }

  getAllClaims(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.baseurl + '/api/Roles/GetAll/' + itemsPerPage+"/"+pageNo, this.httpOptions);
  }

  GetAllRoleNames() {
    return this.http.get(this.baseurl + '/api/Roles/GetAllOffices/', this.httpOptions);
  }

  GetAllOfficelevels() {
    return this.http.get(this.baseurl + '/api/Offices/GetOfficelevel/', this.httpOptions);
  }
  
  GetAllDistrictNames() {
    return this.http.get(this.baseurl + '/api/Offices/GetDistrict/', this.httpOptions);
  }

  getAllDistrictName() {
    debugger;
    return this.http.get(this.baseurl + '/api/Users/GetAllDistrict', this.httpOptions);
  }

  getRolesforSelectedOffice() {

    return this.http.get(this.baseurl + '/api/Roles/getRolesforSelectedOffice', this.httpOptions);
  }

  GetAllOffices(itemsPerPage:number,pageNo:number) {
    debugger;
    return this.http.get(this.baseurl + '/api/Offices/GetAll/' +itemsPerPage+"/"+pageNo, this.httpOptions);
  }


  registerUser(register: Register) {
  debugger;
    return this.http.post(this.baseurl + '/api/Account/Register', register, this.httpOptions);
  }

  registerCustomer(register: Register) {
  
    return this.http.post(this.baseurl + '/api/CustomerAccount/Register', register, this.httpOptions);
  }

  forgetPassword (fp){
    return this.http.post(this.baseurl + '/api/CustomerAccount/ForgotPassword',fp,this.httpOptions);
  }

  createRole(user: User) {
    return this.http.post(this.baseurl + '/api/Roles/Create', user, this.httpOptions);
  }

  updateRole(user: User,roleId:string) {
    return this.http.put(this.baseurl + '/api/Roles/Update/'+roleId, user, this.httpOptions);
  }

  searchRoles(searchCriteria:any,searchText:any,itemsPerPage:number,pageNo: number) {
    return this.http.get(this.baseurl + '/api/Roles/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo, this.httpOptions);
  }  

  searchUsers(searchCriteria:any,searchText:any,itemsPerPage:number,pageNo: number) {
    return this.http.get(this.baseurl + '/api/Users/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo, this.httpOptions);
  }  

  searchOffices(searchCriteria:any,searchText:any, itemsPerPage:number, pageNo: number) {
    return this.http.get(this.baseurl + '/api/Offices/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo, this.httpOptions);
  }  

  updateOffice(office: Office,OfficeId:string) {
       return this.http.put(this.baseurl + '/api/Offices/Update/'+OfficeId, office, this.httpOptions);
  }

  saveClaims(claimsList, roleId) {
    return this.http.put(this.baseurl + '/api/Claims/' + roleId + '/assignClaims', claimsList, this.httpOptions);
  }

  CreateOffice(office: Office) {
    return this.http.post(this.baseurl + '/api/Offices/Create', office, this.httpOptions);
  }

  changePassword(userDetails:any){
    return this.http.post(this.baseurl + '/api/Account/ChangePassword', userDetails, this.httpOptions);
  }

  ResetPasswordPh(userDetails:any){
    return this.http.post(this.baseurl + '/api/CustomerAccount/ResetPasswordPh', userDetails, this.httpOptions);
  }
  ResetPassword(userDetails:any){
    return this.http.post(this.baseurl + '/api/CustomerAccount/ResetPassword', userDetails, this.httpOptions);
  }
  
  changePasswordForTheId(userDetails:any){
    return this.http.put(this.baseurl + '/api/Account/Update', userDetails, this.httpOptions);
  }

  deleteRole(id: string){
    return this.http.put(this.baseurl + '/api/Roles/Delete/'+id, this.httpOptions);
  }

  activateInactivateUser(id: string){
    return this.http.put(this.baseurl + '/api/Users/ActivateInactivate/'+id, null, this.httpOptions);
  }
  
  activateInactivateRoles(id: string){
    return this.http.put(this.baseurl + '/api/Roles/ActivateInactivate/'+id, null, this.httpOptions);
  }

  activateInactivateOffices(id: string){
    return this.http.put(this.baseurl + '/api/Offices/ActivateInactivate/'+id, null, this.httpOptions);
  }
  ConfirmedMail(user) {
    debugger;
    return this.http.post(this.baseurl + '/api/CustomerAccount/ConfirmEmail',user ,this.httpOptions);
  }
  getDistrictName() {
      debugger;
      return this.http.get(this.baseurl + '/api/Users/GetAllDistrict', this.httpOptions);
    }
  
    isServiceNoHavingPhone(serviceNo :string)
{
  return this.http.get(this.baseurl + '/api/CustomerAccount/CheckPhoneNumberAlreadyExist/' + serviceNo, this.httpOptions);
}
resendSMS(serviceNo :string)
{
  return this.http.get(this.baseurl + '/api/CustomerAccount/ResendSMS/' + serviceNo, this.httpOptions);
}
getAllAccountHeads(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.baseurl + '/api/AccountHead/GetAllAccountHeads/' + itemsPerPage+"/"+pageNo, this.httpOptions);
}  
searchAccountHead(searchCriteria:any,searchText:any, itemsPerPage:number,pageNo:number)
{  
  return this.http.get(this.baseurl + '/api/AccountHead/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo,this.httpOptions);
}
deleteAccountHead(accountHead:string)
{   
   return this.http.delete(this.baseurl + '/api/AccountHead/DeleteAccountHead/'+accountHead, this.httpOptions);
}
getAccountForAccountHead(AccountHeadCode:string)
{
  return this.http.get(this.baseurl+'/api/AccountHead/GetAccountHeadByAccountHead/'+AccountHeadCode,this.httpOptions);    
}
updateAccountHead(accounthead : AccountHeadDetails) {
  debugger;
  return this.http.put(this.baseurl + '/api/AccountHead/UpdateAccountHead', accounthead, this.httpOptions);
}  
addAccountHead(accountDetails : AccountHeadDetails) {    
  return this.http.post(this.baseurl + '/api/AccountHead/Create', accountDetails, this.httpOptions);
}
searchAccountSubHead(searchCriteria:any,searchText:any, itemsPerPage:number,pageNo:number)
{  
  return this.http.get(this.baseurl + '/api/AccountSubHead/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo,this.httpOptions);
}
getAllAccountSubHeads(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.baseurl + '/api/AccountSubHead/GetAllAccountSubHeads/' + itemsPerPage+"/"+pageNo, this.httpOptions);
} 
deleteAccountSubHead(accountHead:string, accountSubHead:string)
{   
   return this.http.delete(this.baseurl + '/api/AccountSubHead/DeleteAccountSubHead/'+accountHead + "/" + accountSubHead, this.httpOptions);
}
GetAllAccountHeadValues()
 {
    return this.http.get(this.baseurl+'/api/AccountHead/GetAllAccountHeads', this.httpOptions);
 }
 getAccountSubHeadByAccountHeadAndAccountSubHead(AccountHeadCode:number,AccountSubHeadCode:number)
{
  return this.http.get(this.baseurl+'/api/AccountSubHead/GetAccountSubHeadByAccountHeadAndAccountSubHead/'+AccountHeadCode + "/" +AccountSubHeadCode,this.httpOptions);    
}
updateAccountSubHead(accountSubhead : AccountSubHeadDetails) {
  debugger;
  return this.http.put(this.baseurl + '/api/AccountSubHead/UpdateAccountSubHead', accountSubhead, this.httpOptions);
}   
addAccountSubHead(accountSubDetails : AccountSubHeadDetails) {    
  return this.http.post(this.baseurl + '/api/AccountSubHead/Create', accountSubDetails, this.httpOptions);
}

searchExpenditure(searchCriteria:any,searchText:any, itemsPerPage:number,pageNo:number) {  
  return this.http.get(this.baseurl + '/api/Expenditure/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo,this.httpOptions);
}
deleteExpenditure(expenditureId:number){   
  return this.http.delete(this.baseurl + '/api/Expenditure/DeleteExpenditure/'+expenditureId, this.httpOptions);
}
getAllexpenditureDetails(itemsPerPage: number, pageNo: number) {
return this.http.get(this.baseurl + '/api/Expenditure/GetAllexpenditureDetails/' + itemsPerPage+"/"+pageNo, this.httpOptions);
}  
getexpenditureById(expenditureId: number) {
return this.http.get(this.baseurl + '/api/Expenditure/GetexpenditureById/' + expenditureId, this.httpOptions);
}
getAccountSubHeadByAccountHead(AccountHeadCode:number)
{
  return this.http.get(this.baseurl+'/api/AccountSubHead/GetAccountSubHeadByAccountHead/'+AccountHeadCode,this.httpOptions);
}  
updatExpenditure(expenditure : Expenditure) {
  debugger;
  return this.http.put(this.baseurl + '/api/Expenditure/UpdateExpenditure', expenditure, this.httpOptions);
}    
addExpenditureDetails(expenditure : Expenditure )
{
  return this.http.post(this.baseurl + '/api/Expenditure/Create', expenditure, this.httpOptions);
}

//Sainik Schemes
getAllSainikSchemes(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.baseurl + '/api/SainikSchemes/GetAllSainikSchemes/' + itemsPerPage+"/"+pageNo, this.httpOptions);
}  

addApplicationForm(sainikSchemeApplicationModel : SainikSchemeApplicationModel) {    
  return this.http.post(this.baseurl + '/api/SainikSchemes/Create', sainikSchemeApplicationModel, this.httpOptions);
}

getAllApplicationByTheUser(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.baseurl + '/api/SainikSchemes/GetAllApplicationByTheUser/' + itemsPerPage+"/"+pageNo, this.httpOptions);
} 
getSchemeApplicationDetailsById(applicationId: number) {
  return this.http.get(this.baseurl + '/api/SainikSchemes/GetSchemeApplicationDetailsById/' + applicationId, this.httpOptions);
} 

getSchemeApplicationHistoryById(applicationId: number) {
  return this.http.get(this.baseurl + '/api/SainikSchemes/GetSchemeApplicationHistoryById/' + applicationId, this.httpOptions);
} 
getOfficesApplicationBelongsTo(){
  return this.http.get(this.baseurl + '/api/SainikSchemes/GetOfficesApplicationBelongsTo', this.httpOptions);
}
getAllUsersForOffice(officeId:number){
  return this.http.get(this.baseurl + '/api/SainikSchemes/GetAllUsersForOffice/'+officeId, this.httpOptions);
}
getSainikApplicationStatus(){
  return this.http.get(this.baseurl + '/api/SainikSchemes/GetSainikApplicationStatus', this.httpOptions);
}

getAllApplicationsToBeApprovedByTheUser(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.baseurl + '/api/SainikSchemes/GetAllApplicationsToBeApprovedByTheUser/' + itemsPerPage+"/"+pageNo, this.httpOptions);
} 
getAllApplicationsToBeApprovedByOthers(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.baseurl + '/api/SainikSchemes/GetAllApplicationsToBeApprovedByOthers/' + itemsPerPage+"/"+pageNo, this.httpOptions);
} 
getAllApplicationsClosed(itemsPerPage:number,pageNo:number){  
  return this.http.get(this.baseurl + '/api/SainikSchemes/GetAllApplicationsClosed/' + itemsPerPage+"/"+pageNo, this.httpOptions);
}
searchApplications(searchCriteria:any,searchText:any,itemsPerPage:number,pageNo: number,status:string) {
  return this.http.get(this.baseurl + '/api/SainikSchemes/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo+"/"+status, this.httpOptions);
}  
updateAppliationStatus(statusHistoryModel : SainikSchemeApplicationStatusHistoryModel) {
  debugger;
  return this.http.put(this.baseurl + '/api/SainikSchemes/UpdateSainikApplicationHistory', statusHistoryModel, this.httpOptions);
}  
searchCorrespondancingTracking(searchCriteria:any,searchText:any, itemsPerPage:number, pageNo: number)
{
  return this.http.get(this.baseurl + '/api/CorrespondanceTracking/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo, this.httpOptions);
}
AddCorrespondanceTracking(CorrespondanceTracking:any)
  {
     return this.http.post(this.baseurl + '/api/CorrespondanceTracking/AddCorrespondanceTracking',CorrespondanceTracking,this.httpOptions);
  }

  GetAllInwardOutwardDetailsinGrid(itemsPerPage: number, pageNo: number) 
{
  return this.http.get(this.baseurl + '/api/CorrespondanceTracking/GetAllInwardOutwardDetailsinGrid/' + itemsPerPage+"/"+pageNo, this.httpOptions);
}
uploadcorrespondance(data:FormData) {
  debugger;
  return this.http.post(this.baseurl + '/api/CorrespondanceTracking/image' , data);
}
  GetInwardNo() 
  {
    return this.http.get(this.baseurl + '/api/CorrespondanceTracking/GetInwardNo/' , this.httpOptions);
  }
  GetOutwardNo()
  {
    return this.http.get(this.baseurl + '/api/CorrespondanceTracking/GetOutwardNo/',this.httpOptions);
  }
  GetAllInwardNoToGridbySP(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.baseurl + '/api/CorrespondanceTracking/GetonlyInwardtoGrid/' + itemsPerPage+"/"+pageNo, this.httpOptions);
  }
  

  
GetInwardOutwardtoView(Id: any) 
{   
 debugger;
return this.http.get(this.baseurl + '/api/CorrespondanceTracking/GetByInwardOutwardNumber/' + Id, this.httpOptions);
}

updatecorrespondanceTrackingDetails(Id: Number,CorrespondanceTrackingModelDetails : CorrespondanceTrackingModel){    
  return this.http.put(this.baseurl + '/api/CorrespondanceTracking/UpdateCorrespondanceTrackingDetails/' + Id, CorrespondanceTrackingModelDetails, this.httpOptions);
}
AddSainikGrievances(grievancesLodging:GrievancesLodging)
{
  return this.http.post(this.baseurl + '/api/SainikGrievances/Create/' , grievancesLodging, this.httpOptions);
}
getAllGrievances(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.baseurl + '/api/SainikGrievances/GetAllGrievances/' + itemsPerPage+"/"+pageNo, this.httpOptions);
}  
getGrievanceById(Id:number)
{
  return this.http.get(this.baseurl+'/api/SainikGrievances/GetGrievanceById/'+Id,this.httpOptions);    
}
searchGrievances(searchCriteria:any,searchText:any, itemsPerPage:number,pageNo:number)
{  
  return this.http.get(this.baseurl + '/api/SainikGrievances/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo,this.httpOptions);
}
GetAllGrievancesByDistrictSearch(searchCriteria:any,searchText:any, itemsPerPage:number,pageNo:number)
{
  return this.http.get(this.baseurl + '/api/SainikGrievances/GetAllGrievancesByDistrictSearch/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo,this.httpOptions);
}
getAllGrievancesByDistrict(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.baseurl + '/api/SainikGrievances/GetAllGrievancesByDistrict/' + itemsPerPage+"/"+pageNo, this.httpOptions);
}  
UpdateSainikGrievances(grievancesLodging:GrievancesLodging)
{
  return this.http.put(this.baseurl + '/api/SainikGrievances/UpdateSainikGrievances/' , grievancesLodging, this.httpOptions);
}
  
    userAuthentication(user: Login) {    
      debugger;
      var data = "username=" + user.UserName + "&password=" + user.Password + "&grant_type=password" + "&OTP=" + user.OTP;
     /* const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' })
      }*/
      return this.http.post(this.baseurl + '/token', data);
    }
  

}





// WEBPACK FOOTER //
// ./src/app/registration.service.ts